import { isSlideNotAnamneseSlide } from '@/utils/types/type-validation/isSlideAnamneseSlide';
import { PatientCase } from '@/utils/types/zod/patientCaseSchema';

export const getIndexFirstSlideNotAnamnese = (patientCase: PatientCase) => {
  return patientCase.slides.findIndex(isSlideNotAnamneseSlide);
};
